import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, AnomalieResponse, Anomalia, GlobalFilter } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { AnomalieService} from '../service/anomalie.service';
import { GlobalFilterService} from '../service/global-filter.service';
import 'rxjs/add/operator/timeout';
import { AppConstants } from '../core/app.constants';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-anomalie',
  templateUrl: './anomalie.component.html',
  styleUrls: ['./anomalie.component.css'],
})
export class AnomalieComponent extends BaseComponent implements OnInit {
    
    @Input() scrollableArea: string = null;
    @Input() refresh: Subject<boolean> = null;
    @Input() showHelpMessage: boolean = false;
    @Input() enableLinkFilter: boolean = false;
    
    anomalieList: Anomalia[] = new Array();
    completed: boolean = false;
    blockedAnomalies: boolean = false;
    styleClass: string = "panel panel-warning";
    userContext: UserContext;
    totalCount: number = 0;
    
    
    constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private anomalieService: AnomalieService,
            private globalFilter: GlobalFilterService,
            private datePipe: DatePipe)  
    { 
        super(authAccess, router, messageProvider);
    }

  ngOnInit() 
  {
      if(this.scrollableArea == null) {
          this.scrollableArea = "auto";
      }
      this.userContext = this.authAccess.getUserContext();
      if(this.userContext != null)
      {
          if(this.refresh != null) {
              this.refresh.asObservable().subscribe(value => { this.load(); });
          }
          this.load();
      }
      else {
          this.authAccess.invalidate();
      }
  }
  
  load()
  {
      this.completed = false;
      var response: AnomalieResponse;
      this.anomalieList = [];
      this.totalCount = 0;
      this.anomalieService.getAnomalieForCurrentUser(this.userContext.srmToken).
      subscribe(
           result => {
               response = result;
               this.anomalieList = response.userAnomalies;
               for(let i = 0; i < this.anomalieList.length; ++i) {
                   let current = this.anomalieList[i];
                   if(current.blocking == true && this.blockedAnomalies==false) {
                       this.blockedAnomalies = true;
                       this.styleClass = "panel panel-danger";
                   }
               }
               this.completed = true;
               this.totalCount = this.anomalieList.length;
               this.sort();
               if(this.totalCount > 10) {
                   this.anomalieList = this.anomalieList.slice(0, 10);
               }
           },
           error => {
               this.completed = true;
               this.handleError(error);
           }); 
  }
  
  setGlobalFilterAnomalyDate(date: Date)
  {
      let _date : Date = AppConstants.parseDate(this.datePipe.transform(date, "dd/MM/yyyy"));
      let filter: GlobalFilter = new GlobalFilter();
      filter.dateFrom = _date;
      filter.dateTo = filter.dateFrom;
      this.globalFilter.setGlobalFilter(filter);
  }
  
  sort() 
  {
      this.anomalieList = this.anomalieList.sort((a1, a2) => 
          {
              if(a1.priority == a2.priority) {
                  let d1 = this.datePipe.transform(a1.date, "yyyyMMdd");
                  let d2 = this.datePipe.transform(a2.date, "yyyyMMdd");
                 return d1 > d2 ? -1 : 1;
              }
              else return a1.priority < a2.priority ? -1 : 1;
          });
  }
}



// WEBPACK FOOTER //
// ./src/app/anomalie/anomalie.component.ts